<template>
  <div class="query-header">
    <vs-button
      v-if="isAuth('sys:menu:save')"
      color="primary"
      type="filled"
      @click="$emit('add')"
    >新增</vs-button>
<!--          size="small"
-->
  </div>
</template>

<script>
export default {
  name: "queryHeader",
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
}
</style>
